<div class="product-page-content">

  <div class="intro-row">
    <!-- Left side: Product image -->
    <div class="image-wrapper" *ngIf="product.logo">
      <img [src]="product.logo" [alt]="product.logo" class="product-image" />
    </div>

    <!-- Right side: Product card -->
    <div class="card-wrapper">
      <oth-card [bodyTemplate]="bodyTemplate" [cardClass]="'transparent-card'" [headerTemplate]="headerTemplate"
        class="product-card">
        <ng-template #headerTemplate>
          <div class="header">
            <h3>{{ product.name }}</h3>
          </div>
        </ng-template>
        <ng-template #bodyTemplate>
          <div class="body">
            <div class="product-description" [innerHTML]="product.longDescription"></div>
            <div class="button-wrapper">
              <oth-button (click)="redirect(product.url)" i18n-text="@@productPage.professional.button"
                text="Click here to know more">
              </oth-button>
            </div>
          </div>
        </ng-template>
      </oth-card>
    </div>
  </div>

  <!-- Screenshots carousel stays below -->
  <div *ngIf="product.screenshots" class="screenshots-wrapper">
    <app-screenshot-swiper [screenshots]="product.screenshots"></app-screenshot-swiper>
  </div>

</div>